import OrnamentalsForecastWeatherData from "./OrnamentalsForecastWeatherData";

export default OrnamentalsForecastWeatherData;